import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteMensagemFiscal } from '../service';
import {
  DELETE_MENSAGEM_FISCAL,
  DELETE_MENSAGEM_FISCAL_PENDING,
  DELETE_MENSAGEM_FISCAL_SUCCESS,
  DELETE_MENSAGEM_FISCAL_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteMensagemFiscal(action) {
  yield put({ type: DELETE_MENSAGEM_FISCAL_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.MENSAGEM_FISCAL_EXCLUIR);
  
  try {
    const a = yield call(deleteMensagemFiscal, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_MENSAGEM_FISCAL_SUCCESS, id: action.id });
  
    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });
  } catch (_) {
    yield put({ type: DELETE_MENSAGEM_FISCAL_FAILURE });

    AlertError('Falha ao excluir o registro! Verifique se a mensagem não possuí lançamentos vinculados e tente novamente...');
  }
}

export default function* watchDeleteMensagemFiscal() {
  yield takeLatest(DELETE_MENSAGEM_FISCAL, sagaDeleteMensagemFiscal)
}
